jQuery(document).ready(function () {
  if (jQuery(".page-banner").length) {
    jQuery("header").addClass("transparent");
  }
});

//jQuery('a[href^="http"]').not('a[href^="{{ shop.url }}"]').attr('target', '_blank');

jQuery(document).ready(function () {
  jQuery(".single-product-slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $("a.open-bio").click(function () {
    $(this).nextAll(".bio-more").first().toggle();
    $(this).toggleClass("active");
    return false;
  });

  $(".custom-blog-slider").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
});

// Start Free Samples JS

jQuery(document).ready(function () {
  slick();
});

jQuery(".add-sample").click(function () {
  jQuery("#pre-loader").css("display", "block");
  var product_handle = this.id;
  jQuery.getJSON("/products/" + product_handle + ".js", function (product) {
    console.log(product);

    jQuery.getJSON("/cart.js", function (cart) {
      var items = cart.items;
      var status = check_item(product.id, items);
      if (status == 0) {
        var count = countElement("Sample", items);
        if (count == 1) {
          jQuery("#pre-loader").css("display", "none");
          jQuery(".sample-warning").css("display", "block");
          alert("You can only add one free samples");
        } else {
          jQuery(product.variants).each(function (i, v) {
            var var_id = v.id;
            jQuery
              .post(
                "/cart/add.js",
                {
                  id: var_id,
                },
                null,
                "json"
              )
              .done(function () {
                //$('#pre-loader').css('display','none');
                window.location.replace("/cart");
              })
              .fail(function ($xhr) {
                window.location.replace("/cart");
                var data = $xhr.responseJSON;
                console.log(data.description);
              });
          });
        }
      } else {
        jQuery("#pre-loader").css("display", "none");
        alert("Sample already added to cart");
      }
    });
  });
});

function countElement(item, array) {
  var count = 0;
  jQuery.each(array, function (i, v) {
    if (v.vendor === item) count++;
  });
  return count;
}
function check_item(id, array) {
  var count = 0;
  jQuery.each(array, function (i, v) {
    if (v.product_id === id) count = 1;
  });
  return count;
}

jQuery("#sample-box").click(function () {
  if (jQuery("#sample-products").is(":hidden")) {
    jQuery(".sample-icon-down").css("display", "none");
    jQuery(".sample-icon-up").css("display", "inline-block");
    jQuery("#sample-products").show();
    jQuery(".sample-slider").slick("unslick");
    slick();
  } else {
    jQuery(".sample-icon-down").css("display", "inline-block");
    jQuery(".sample-icon-up").css("display", "none");
    jQuery("#sample-products").hide();
  }
});

function slick() {
  jQuery(".sample-slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 1500,
    arrows: true,
    dots: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}

Handlebars.registerHelper("if_eq", function (a, b, opts) {
  if (a == b)
    // Or === depending on your needs
    return opts.fn(this);
  else return opts.inverse(this);
});

// End Free Samples JS

$(document).on("click", ".make-an-enquiry-btn", function (e) {
  e.preventDefault();
  $(".popup-overlay.contact-physicians").fadeIn("slow");
  $("header").fadeOut("slow");
});
$(".pop-close").click(function () {
  $(".popup-overlay").fadeOut("slow");
  $("header").fadeIn("slow");
});
$(document).on("click", ".popup-overlay.contact-physicians", function () {
  $(this).fadeOut("slow");
  $("header").fadeIn("slow");
});
$(document).on("keydown", function (e) {
  if (e.keyCode === 27) {
    $(".popup-overlay.contact-physicians").fadeOut("slow");
    $("header").fadeOIn("slow");
  }
});
$(document).on("click", ".popup-body", function (e) {
  e.stopPropagation();
});

$(document).on("click", ".resellers", function (e) {
  e.preventDefault();
  $(".popup-overlay.contact-resellers").fadeIn("slow");
  $("header").fadeOut("slow");
});
$(".pop-close").click(function () {
  $(".popup-overlay").fadeOut("slow");
  $("header").fadeIn("slow");
});
$(document).on("click", ".popup-overlay.contact-resellers", function () {
  $(this).fadeOut("slow");
  $("header").fadeIn("slow");
});
$(document).on("keydown", function (e) {
  if (e.keyCode === 27) {
    $(".popup-overlay.contact-resellers").fadeOut("slow");
    $("header").fadeOut("slow");
  }
});
$(document).on("click", ".popup-body", function (e) {
  e.stopPropagation();
});

$(document).on("change", "#et-cartform .cart__product-qty", function () {
  var qty = $(this).val();
  var id = $(this).data("variant_id");

  console.log(id + "=" + qty);

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    async: true,
    data: {
      quantity: qty,
      id: id,
    },
    success: function (cart) {
      $("#MainContent").load("/cart?view=view"); // called the content of cart template
    },
    error: function () {
      alert("Error adding product to cart.");
    },
  });
});

jQuery(document).ready(function() {
  $('.rc-pbs-buttons__wrapper .rc-pbs-button-item input').change(function () {
    var value = $(this).val();

    if (value != 'subscribe') {
      $('.rc-pbs-frequency-selectors').hide();
    }

    if (value != 'bundle') {
      $('.bundle-text').hide();
      if (value == 'onetime') {
        $('.rc-option__onetime .rc-radio__label.rc_widget__option__label').click();
      }

      if (value == 'subscribe') {
        $('.rc-pbs-frequency-selectors').show();
        $('.rc_widget__option--subsave label.rc-radio__label.rc_widget__option__label').click();
      }
    } else {
      $('.bundle-text').show();
    }
  });

  $('.rc-pbs-frequency-selectors #rc-pbs-frequency-num').change(function () {
    var value = $(this).val();
    var freqValue = $('.rc-selling-plans__dropdown option[data-plan-option="'+value+'"]').attr('value');
    $('.rc-selling-plans__dropdown').val(freqValue).trigger('change');
    var swatchChange = document.querySelector('.rc-selling-plans__dropdown');
    swatchChange.dispatchEvent(new Event('change'));
  });

  /*$('.rc-pbs-frequency-selectors #rc-pbs-frequency-type').change(function () {
    var value = $(this).val();
    var selectedText = $(this).find('option:selected').text();
    $('.bold-ro__frequency-type').val(value).trigger('change');
    var swatchChange = document.querySelector('.bold-ro__frequency-type');
    swatchChange.dispatchEvent(new Event('change'));
    $('.bold-ro__frequency-type-text').val(selectedText);
  });*/

  var rcWidget = setInterval(function () {
    if ($('.rc-container-wrapper.rc_container_wrapper').length > 0) {
      $('#rc-pbs-frequency-text').html($('.rc-option__subsave label.rc-radio__label').html());
      $('.rc-pbs-buttons__wrapper').css('display', 'flex');

      if($('.rc-selling-plans__dropdown').length) {
        var freq = [], optionHtml = '';
        $('.rc-selling-plans__dropdown option').each(function() {
          var frequencyText = $(this).data('plan-option');
          // frequencyText = frequencyText.replace('Delivery every ', '');

          // var frequencyArray = frequencyText.split(' ');
          //   freqUnit = frequencyArray[1];
          //   freq.push(frequencyArray[0]);

          optionHtml += `<option value="${frequencyText}">${frequencyText}</option>`;
        });

        $('#rc-pbs-frequency-num').append(optionHtml);
      }
      clearInterval(rcWidget);
    }
  }, 200);
});

jQuery(document).ready(function () {
  $(document).on("DOMSubtreeModified", function (e) {
    if (
      e.target.className ==
      "drawer drawer--right is-transitioning drawer--is-open"
    ) {
      jQuery(".smsbump-sub-form").hide();
    }
    if (e.target.className == "drawer drawer--right is-transitioning") {
      jQuery(".smsbump-sub-form").show();
    }
  });
});

$(document).on("click", ".sezzle-shopify-info-button", function () {
  if ($(".sezzle-checkout-modal-lightbox.close-sezzle-modal").length > 1) {
    $(".sezzle-checkout-modal-lightbox.close-sezzle-modal")
      .eq(0)
      .css({ display: "block", "max-height": "100%" });
    $(".sezzle-checkout-modal-lightbox.close-sezzle-modal").eq(1).remove();
  }
});

$(document).ready(function () {
  loaderRemover();
  $(window).resize(function () {
    loaderRemover();
  });

  function loaderRemover() {
    var width = $(window).width();

    //if(width >= 768){
    $(".hero-desktop-remove")
      .removeClass("loading")
      .removeClass("loading--delayed");
    //}
  }
});


/* Mutation observer */
$(document).ready(function () 
{
  if($('#CartDrawer').length) 
  {
    function updateCheckoutPromoBar()
    {
      let free_ship = 74.99;
      let price = $('.drawer__footer .grid.grid--full:not([style="display:none;"]) .ajaxcart__price').text().trim();
      let checkouttext = $('#PageContainer #CartDrawer form a.btn--full').text();
      $('#PageContainer #CartDrawer form a.btn--full').text(price + ' - ' +checkouttext);
      
      price = price.replace('Rs.',' ');
      price = price.replace('$',' ');
      price = parseFloat(price);
      if(typeof price === 'number' && !isNaN(price))
      {
        if(price >= free_ship)
        {
          $('.checkout-promo-bar').text('Congrats - you qualify for free standard shipping!');
        }
        else
        {
          price = (free_ship-price).toFixed(2);
          let msg = `<strong>FREE</strong> shipping is only $${price} away!`;
          $('.checkout-promo-bar').html(msg);
        }
      }
    }

    const parent = document.getElementById('CartDrawer');
    let observer = new MutationObserver((mutations) => 
    {
      mutations.forEach(function (mutation) 
      {
        mutation.addedNodes.forEach(node => 
        {
          if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('drawer__footer'))
          {
            updateCheckoutPromoBar();
          }
        });
      });
    });
    const config = { childList: true, subtree: true };
    observer.observe(parent, config);
  }
});


document.addEventListener('DOMContentLoaded', function() 
{
  function wcShowSelectWhenOptionsRead()
  {
    let found = false;
    let count = 0;
    let interval = setInterval(() => 
    {  
      if (!found) 
      {
        const selectBox = document.getElementById('rc-pbs-frequency-num');
        if(selectBox && selectBox.options.length > 0) 
        {
          //selectBox.style.display = 'block'; 
          clearInterval(interval);
          found = true;

          setTimeout(() => 
          {
            wcChangeSubscriptionCycleOption();
          },150);

        }
      }
      if (count > 19) 
      {
        clearInterval(interval);
      }
      count++;
    }, 500);
  }
  wcShowSelectWhenOptionsRead();
});

function wcChangeSubscriptionCycleOption()
{
  const select = document.querySelector('.custom-form-row .rc-pbs-selectors select');
  let option = document.querySelector('.custom-form-row .rc-pbs-selectors select option:nth-child(3)');

  if(select !== null && select !== undefined && typeof select === 'object' && 
    option !== null && option !== undefined && typeof option === 'object')
  {
    option.selected = true;
    select.dispatchEvent(new Event('change'));
  }
}

function wcChangeHiddenSubscriptionCycleOption()
{
  let selectedIndex = parseInt($('#rc-pbs-frequency-num').prop('selectedIndex'))+1;
  if(typeof selectedIndex === 'number' && !isNaN(selectedIndex))
  {
    const select = document.querySelector('.custom-form-row .rc-pbs-selectors select');
    const option = document.querySelector(`.custom-form-row .rc-pbs-selectors select option:nth-child(${selectedIndex})`);
    
    if(select !== null && select !== undefined && typeof select === 'object' && 
      option !== null && option !== undefined && typeof option === 'object')
    {
      option.selected = true;
      select.dispatchEvent(new Event('change'));
    }
  }
}
$(document ).ready(function() 
{
  $('.rc-pbs-buttons__wrapper .rc-pbs-button-item input').change(function(e) 
  {
if( e.target.value =='subscribe' )
{
  setTimeout(() => 
  {
    const selectors = document.querySelector('.rc-pbs-frequency-selectors');
    if(selectors ) 
    {
      selectors.style.display = 'block'; 
    }
    const selectBox = document.getElementById('rc-pbs-frequency-num');
    if(selectBox && selectBox.options.length > 0) 
    {
      selectBox.style.display = 'block'; 
    }
    wcChangeSubscriptionCycleOption();
  },150);  
}
  });
  $('fieldset.variant-input-wrap .variant-input input[type="radio"]').change(function(e) 
  {
    setTimeout(() => 
    {
      wcChangeHiddenSubscriptionCycleOption();
    },250); 
  });
});

jQuery(document).ready(function() {
 jQuery("div.open-bio").click(function() {
   jQuery(this).next('.bio-more').toggle();
   jQuery(this).toggleClass('active');
 });
}); 

function checkIfDrawerIsOpen(ele)
{
  setTimeout(() => {
    let isOpen = $(ele).attr('data-open');  
    if(isOpen == 'false')
    {
      $('#CartDrawer button.drawer__close-button').click();
      $('html, body').removeClass('js-drawer-open');

    }
  }, 500);      
}

function drawerMutationObserver()
{
  if($('.apz-component-drawer').length) 
  {
    const ele = document.querySelector('.apz-component-drawer');

    const observer = new MutationObserver((mutations) => 
    {
      checkIfDrawerIsOpen(ele);
    });
    const config = { attributes: true,childList: true, subtree: true };
    observer.observe(ele, config);    
  }
}

function checkIfDrawerIsReady()
{
  let found = false;
  let count = 0;
  let interval = setInterval(() => 
  {  
    if (!found) 
    {
      const element = document.querySelector('.apz-component-drawer');
      if (element) 
      {
        clearInterval(interval);
        found = true;
        setTimeout(function() 
        {
          drawerMutationObserver();
        }, 500);
      }
    }
    if (count > 25) {
      clearInterval(interval);
    }
    count++;
  }, 500);  
}


$(document).ready(function () 
{
  checkIfDrawerIsReady();
});

$(document).on('click','.apz-component-drawer .header-section-close',function(e) 
{
  $('#CartDrawer button.drawer__close-button').click();  
});


function wcSelectOneTimePurchase() 
{
  let found = false;
  let count = 0;
  let interval = setInterval(() => 
  {
    console.log(' interval1-1 ');
    if (!found) 
    {
      console.log(' interval1-2 ');
      const element = document.querySelector('.custom-form-row input[type="radio"]#onetime');
      if (element) 
      {
        console.log(' interval1-3 ');
        clearInterval(interval);
        found = true;

        setTimeout(function () {
          element.click();
        }, 500);
      }
    }
    if (count > 19) {
      clearInterval(interval);
    }
    count++;
  }, 500);
  

  let found2 = false;
  let count2 = 0;
  let interval2 = setInterval(() => 
  {
    console.log(' interval2-1 ');
    if (!found2) 
    {
      console.log(' interval2-2 ');
      const element = document.querySelector('.rc_widget__option__selector input[type="radio"].rc_widget__option__input--onetime');
      if (element) 
      {
        console.log(' interval2-3 ');
        clearInterval(interval2);
        found2 = true;

        setTimeout(function () {
          element.click();
        }, 500);
      }
    }
    if (count2 > 19) {
      clearInterval(interval2);
    }
    count2++;
  }, 500);
}
wcSelectOneTimePurchase();

jQuery( document ).ready(function() 
{
  jQuery('.announcement-slider').slick({
    autoplay: true,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: false,
    nextArrow: false,
    fade: true,
    autoplaySpeed: 4000,
  });
});

jQuery( document ).ready(function() 
{
  jQuery('.image-slider').slick({
    infinite: false,
    slidesToShow: 2.3,
    slidesToScroll: 1,
    prevArrow: false,
    nextArrow: false,
    dots: true
  });
});


	document.querySelector('.klaviyo_form_trigger').addEventListener('click', function (){
		window._klOnsite = window._klOnsite || [];
		window._klOnsite.push(['openForm', 'VqQmfh']);
	});




function checkIfCartDrawerIsReady()
{
  let found = false;
  let attempts = 0;
  const maxAttempts = 15;
  const intervalTime = 500;
  let interval = setInterval(() => 
  {  
    if (!found) 
    {
      const element = document.querySelector('.apz-component-drawer-content');
      if (element) 
      {
        clearInterval(interval);
        found = true;
        cartDrawerMutationObserver();
      }
    }
    if (attempts >= maxAttempts) 
    {
      clearInterval(interval);
    }
    attempts++;
  }, intervalTime);
}
checkIfCartDrawerIsReady();

function cartDrawerMutationObserver()
{
  const ele = document.querySelector('.apz-component-drawer-content');
  if(ele) 
  {
    const observer = new MutationObserver((mutations) => 
    {
      let flag = false;
      mutations.forEach((mutation) => 
      {
        if (mutation.target.classList.contains('apz-component-drawer-content') || mutation.target.classList.contains('am_rec_item_wrap')) 
        {
          flag = true;
        }
      });
      if(flag)
      {
        changeCheckoutButtonText();
      } 
    });
    const config = { attributes: true,childList: true, subtree: true };
    observer.observe(ele, config);
  }
}

function changeCheckoutButtonText()
{
  let price = $('.checkout-section-subtotal div:last-child').text();
  let buttonText = 'proceed to checkout';
  if(price.replace('$', '') > 0)
  {
    buttonText = price+' - '+buttonText;
  }
  $('.checkout-section-checkout-button-text').text(buttonText);
}